import {
  EmailAddressSchema,
  TeamIdSchema,
  UserIdSchema,
} from '@mntn-dev/domain-types'
import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'

export const AuthSessionPrincipalUserSchema = z.object({
  userId: UserIdSchema,
  emailAddress: EmailAddressSchema,
  teamIds: z.array(TeamIdSchema).optional(),
})

export type AuthSessionPrincipalUser = ZodSimplify<
  typeof AuthSessionPrincipalUserSchema
>
